import AddressDto from '../CompanyAddresses/CompanyAddressDto';
//import IndustryDto from '@/models/IndustryDto';
//import RegionDto from '@/models/RegionDto';
import BaseEntityDto from '@/models/Shared/BaseEntityDto';
import GeoPoint from '@/models/Shared/GeoPoint';
import IAddressLine from '@/models/Shared/IAddressLine';
import AgencyBrandThemeMode from './AgencyBrandThemeMode';

export default class AgencyDto extends BaseEntityDto implements IAddressLine {
    status = 0;
    registeredName = '';    
    brandName = '';
    brandPrimaryColour = '#3f51b5';
    brandThemeMode: AgencyBrandThemeMode = AgencyBrandThemeMode.Light;
    taxNumber = '';    
    registrationNumber = ''; 
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;   
    website = '';
    biography = '';
    avatar = '';
    workerBookingOfferHeader = '';
    workerBookingOfferFooter = '';
    workerBookingConfirmationHeader = '';
    workerBookingConfirmationFooter = '';
    workerBookingConfirmationCheckboxText = '';
    workerDashboardFooter  = '';
    generalHealthAndSafetyInformation = '';
    generalTrainingInformation = '';
    identityProvider = 2;
    emailDomain = '';
    //industries: IndustryDto[];
    //regions: RegionDto[];
}